<template>
    <Warning v-if="readonly" icon="mdi-lock">
        {{
            $translate("readonlyAccountMessage")
        }}
        <v-row class="mt-2 d-flex align-center">
            <v-col cols="12" sm="3">
                <Button
                    class="w-100 w-sm-auto"
                    :text="$translate('contactUs')"
                    :color="'primary'"
                    icon="email"
                    @click="sendMail"
                />
            </v-col>
        </v-row>
    </Warning>
</template>

<script>
import GlobalMixin from "@/mixins/global";

export default {
    mixins: [GlobalMixin],
    computed: {
        readonly() {
            return this.$store.state.session.readonly;
        },
        alertType() {
            return "error";
        },
    },
    methods: {
        sendMail() {
            window.open("mailto:contact@safetee.io");
        },
    },
    i18n: {
        messages: {
            en: {
                readonlyAccountMessage: "Your account is currently in readonly mode. Please contact your sales representative at the following address",
                contactUs: "Contact us",
            },
            fr: {
                readonlyAccountMessage: "Votre compte est actuellement en mode lecture seule. Veuillez contacter votre représentant commercial à l'adresse suivante",
                contactUs: "Contactez-nous",
            },
        },
    },
};
</script>
